import { getMyBoards } from './getMyBoards';
import { getMemberType } from './memberships';
import type { PermissionLevel, AccessLevel } from './types';

export const getMyOwnedBoards = <Board>(member: {
  id: string;
  idBoards: string[];
  idPremOrgsAdmin: string[];
  idEnterprisesAdmin: string[];
  memberType: 'normal' | 'ghost';
  boards: ({
    id: string;
    memberships: {
      idMember: string;
      memberType: 'admin' | 'normal' | 'observer';
    }[];
    organization?: {
      id: string;
      memberships: {
        idMember: string;
        memberType: 'admin' | 'normal';
        unconfirmed: boolean;
        deactivated: boolean;
      }[];
      enterprise?: {
        idAdmins: string[];
      } | null;
      products: number[];
      prefs: {
        boardVisibilityRestrict?: Partial<
          Record<PermissionLevel, AccessLevel>
        > | null;
        boardDeleteRestrict?: Partial<
          Record<PermissionLevel, AccessLevel>
        > | null;
      };
    } | null;
  } & Board)[];
}) => {
  return getMyBoards<typeof member.boards[number]>(member).filter(
    (board) => getMemberType(member, board) === 'admin',
  );
};
